import { createSlice } from "@reduxjs/toolkit"
import { Section } from "src/pages/home/room-detail/drawer/general/index.type"

export interface suciaState {
    drawerSelectedInitialSection: Section | null
}

const initialState: suciaState = {
    drawerSelectedInitialSection: null,
}

export const suciaSlice = createSlice({
    name: "sucia",
    initialState,
    reducers: {
        selectSuciaInitialSection: (state, action: {payload: Section | null, type: string}) => {
            state.drawerSelectedInitialSection = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { selectSuciaInitialSection } = suciaSlice.actions

export default suciaSlice.reducer
